import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { IoCheckmarkCircle, IoClose, IoCloseCircle, IoInformationCircle, IoWarning } from 'react-icons/io5';

const ConfirmModal = (props) => {
    const {
        handleClose,
        message,
        title = "Confirmation",
        onSubmitConfirm,
        open,
        type = "info",
        confirmText = "CREATE",
        cancelText = "Cancel",
        maxWidth = "sm",
        note,
        confirmBtnProps = {},
        cancelBtnProps = {}
    } = props;

    const getIcon = () => {
        switch (type) {
            case 'warning':
                return <IoWarning className="w-8 h-8 text-amber-500" />;
            case 'success':
                return <IoCheckmarkCircle className="w-8 h-8 text-emerald-500" />;
            case 'error':
                return <IoCloseCircle className="w-8 h-8 text-rose-500" />;
            default:
                return <IoInformationCircle className="w-8 h-8 text-[#313C4C]" />;
        }
    };

    const getIconBackgroundClass = () => {
        switch (type) {
            case 'warning':
                return "bg-amber-50";
            case 'success':
                return "bg-emerald-50";
            case 'error':
                return "bg-rose-50";
            default:
                return "bg-sky-50";
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={maxWidth}
            fullWidth
            PaperProps={{
                className: "rounded-none overflow-hidden border border-slate-200 shadow-2xl",
                style: { fontFamily: '"Roboto", sans-serif' }
            }}
        >
            {/* Header Bar matching CustomAddModal / CustomShowModal */}
            <div className="flex items-center justify-between w-full px-4 py-2 bg-[#f8fafc] border-b border-slate-200">
                <span className="text-[#313C4C] text-[15px] font-semibold tracking-wide">{title}</span>
                <button
                    onClick={handleClose}
                    className="p-1 rounded-full text-slate-500 hover:text-slate-800 hover:bg-slate-200/80 transition-colors border-none bg-transparent cursor-pointer flex items-center justify-center"
                    title="Close"
                >
                    <IoClose className="w-4 h-4" />
                </button>
            </div>

            {/* Compact Dialog Body */}
            <DialogContent className="!px-5 !py-4 bg-white">
                {/* Icon */}
                <div className="flex justify-center mb-3">
                    <div className={`w-12 h-12 rounded-full ${getIconBackgroundClass()} flex items-center justify-center`}>
                        {getIcon()}
                    </div>
                </div>

                {/* Message */}
                <div className="text-center mb-3">
                    <p className="text-slate-700 text-sm leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Note/Warning Box */}
                {note && (
                    <div className="bg-rose-50 border border-rose-200 rounded-md px-3 py-2 text-center">
                        <p className="text-rose-700 text-xs">
                            <strong className="font-semibold">Note:</strong> {note}
                        </p>
                    </div>
                )}
            </DialogContent>

            {/* Footer Bar matching CustomAddModal / CustomShowModal */}
            <DialogActions className="px-4 py-2 bg-slate-50 border-t border-slate-200 flex items-center justify-end gap-2.5">
                <button
                    onClick={handleClose}
                    {...cancelBtnProps}
                    className={`h-[28px] px-3.5 text-[11.5px] font-semibold text-slate-700 bg-white hover:bg-slate-100 border border-slate-300 rounded shadow-2xs transition-colors uppercase tracking-wider cursor-pointer ${cancelBtnProps.className || ""}`}
                >
                    {cancelText}
                </button>
                <button
                    onClick={onSubmitConfirm}
                    {...confirmBtnProps}
                    className={`h-[28px] px-3.5 text-[11.5px] font-semibold text-white bg-[#313C4C] hover:bg-[#1e2632] border border-[#313C4C] rounded shadow-2xs transition-colors uppercase tracking-wider cursor-pointer ${confirmBtnProps.className || ""}`}
                >
                    {confirmText}
                </button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmModal;
